import React, { useState, useEffect } from 'react';
import { getPlantillas, getPlantilla, createPlantilla, updatePlantilla, deletePlantilla, createPlantillaOftalmologica } from '../../api/plantillaService';

const Plantillas = () => {
  const [plantillas, setPlantillas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [editandoId, setEditandoId] = useState(null);
  const [nuevaPlantilla, setNuevaPlantilla] = useState({
    nombre: '',
    descripcion: '',
    esPredeterminada: false,
    secciones: []
  });
  const [plantillaEditada, setPlantillaEditada] = useState({
    nombre: '',
    descripcion: '',
    esPredeterminada: false,
    secciones: []
  });
  const [mostrandoForm, setMostrandoForm] = useState(false);

  // Cargar plantillas al iniciar el componente
  useEffect(() => {
    const cargarPlantillas = async () => {
      try {
        setLoading(true);
        const response = await getPlantillas();
        
        if (response.data && response.data.data) {
          setPlantillas(response.data.data);
          setError(null);
        }
      } catch (err) {
        console.error('Error al cargar plantillas:', err);
        setError('No se pudieron cargar las plantillas. Por favor, intente de nuevo más tarde.');
        setPlantillas([]);
      } finally {
        setLoading(false);
      }
    };
    
    cargarPlantillas();
  }, []);

  useEffect(() => {
    const handleDashboardAction = (event) => {
      if (event?.detail?.action === 'nueva-plantilla') {
        iniciarNuevaPlantilla();
      }
    };

    window.addEventListener('dashboard-action', handleDashboardAction);
    return () => window.removeEventListener('dashboard-action', handleDashboardAction);
  }, []);

  const iniciarNuevaPlantilla = () => {
    setNuevaPlantilla({
      nombre: '',
      descripcion: '',
      esPredeterminada: false,
      secciones: []
    });
    setMostrandoForm(true);
  };

  const guardarNuevaPlantilla = async () => {
    if (nuevaPlantilla.nombre.trim() === '') {
      alert('Por favor ingrese al menos el nombre de la plantilla');
      return;
    }

    try {
      const response = await createPlantilla(nuevaPlantilla);
      if (response.data && response.data.data) {
        // Actualizar la lista de plantillas
        setPlantillas([...plantillas, response.data.data]);
        // Limpiar el formulario y cerrarlo
        setNuevaPlantilla({
          nombre: '',
          descripcion: '',
          esPredeterminada: false,
          secciones: []
        });
        setMostrandoForm(false);
      }
    } catch (error) {
      console.error('Error al crear plantilla:', error);
      alert('Error al crear la plantilla. Por favor, intente de nuevo.');
    }
  };

  const iniciarEdicion = async (plantilla) => {
    try {
      // Obtener plantilla con todos sus detalles (secciones y campos)
      const response = await getPlantilla(plantilla.id);
      if (response.data && response.data.data) {
        setPlantillaEditada(response.data.data);
        setEditandoId(plantilla.id);
      }
    } catch (error) {
      console.error('Error al obtener detalle de plantilla:', error);
      alert('Error al cargar los detalles de la plantilla');
    }
  };

  const guardarEdicion = async () => {
    if (plantillaEditada.nombre.trim() === '') {
      alert('Por favor ingrese al menos el nombre de la plantilla');
      return;
    }

    try {
      const response = await updatePlantilla(editandoId, plantillaEditada);
      if (response.data && response.data.data) {
        // Actualizar la lista de plantillas
        setPlantillas(plantillas.map(p => p.id === editandoId ? response.data.data : p));
        setEditandoId(null);
      }
    } catch (error) {
      console.error('Error al actualizar plantilla:', error);
      alert('Error al actualizar la plantilla. Por favor, intente de nuevo.');
    }
  };

  const eliminarPlantilla = async (id) => {
    if (window.confirm('¿Está seguro de que desea eliminar esta plantilla?')) {
      try {
        await deletePlantilla(id);
        setPlantillas(plantillas.filter(p => p.id !== id));
      } catch (error) {
        console.error('Error al eliminar plantilla:', error);
        // Si el error es por estar asociada a historias clínicas
        if (error.response && error.response.status === 400) {
          alert(error.response.data.message || 'No se puede eliminar la plantilla porque está siendo utilizada en historias clínicas');
        } else {
          alert('Error al eliminar la plantilla. Por favor, intente de nuevo.');
        }
      }
    }
  };
  
  const crearPlantillaOftalmologicaPredeterminada = async () => {
    try {
      const response = await createPlantillaOftalmologica();
      if (response.data && response.data.data) {
        // Actualizar la lista de plantillas
        setPlantillas([...plantillas, response.data.data]);
        alert('Plantilla oftalmológica creada correctamente');
      }
    } catch (error) {
      console.error('Error al crear plantilla oftalmológica:', error);
      alert('Error al crear la plantilla oftalmológica. Por favor, intente de nuevo.');
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
        <h2>Plantillas</h2>
        {!mostrandoForm && (
          <div style={{ display: 'flex', gap: '10px' }}>
            <button 
              onClick={crearPlantillaOftalmologicaPredeterminada}
              style={{
                backgroundColor: '#3f51b5',
                color: 'white',
                border: 'none',
                padding: '10px 15px',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              <i className="fas fa-eye" style={{ marginRight: '5px' }}></i>
              Plantilla Oftalmológica
            </button>
            <button 
              onClick={iniciarNuevaPlantilla}
              style={{
                backgroundColor: '#4caf50',
                color: 'white',
                border: 'none',
                padding: '10px 15px',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              <i className="fas fa-plus" style={{ marginRight: '5px' }}></i>
              Nueva Plantilla
            </button>
          </div>
        )}
      </div>

      {/* Formulario para nueva plantilla */}
      {mostrandoForm && (
        <div style={{ 
          backgroundColor: 'white', 
          padding: '20px', 
          borderRadius: '8px', 
          marginBottom: '20px',
          boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
        }}>
          <h3 style={{ marginTop: '0', marginBottom: '15px' }}>Nueva Plantilla</h3>
          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', marginBottom: '5px' }}>Nombre:</label>
            <input 
              type="text" 
              value={nuevaPlantilla.nombre} 
              onChange={(e) => setNuevaPlantilla({...nuevaPlantilla, nombre: e.target.value})}
              placeholder="Nombre de la plantilla"
              style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }}
            />
          </div>
          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', marginBottom: '5px' }}>Descripción:</label>
            <textarea 
              value={nuevaPlantilla.descripcion} 
              onChange={(e) => setNuevaPlantilla({...nuevaPlantilla, descripcion: e.target.value})}
              placeholder="Descripción de la plantilla"
              rows="5"
              style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }}
            ></textarea>
            
            <div style={{ marginBottom: '15px', marginTop: '15px' }}>
              <label style={{ display: 'flex', alignItems: 'center' }}>
                <input 
                  type="checkbox" 
                  checked={nuevaPlantilla.esPredeterminada} 
                  onChange={(e) => setNuevaPlantilla({...nuevaPlantilla, esPredeterminada: e.target.checked})}
                  style={{ marginRight: '8px' }}
                />
                Establecer como plantilla predeterminada
              </label>
            </div>
            
            <p style={{ color: '#666', fontSize: '14px', marginTop: '15px' }}>
              Después de crear la plantilla, podrá agregar secciones y campos desde la pantalla de edición.
            </p>
          </div>
          <div style={{ display: 'flex', gap: '10px' }}>
            <button 
              onClick={guardarNuevaPlantilla}
              style={{
                backgroundColor: '#4caf50',
                color: 'white',
                border: 'none',
                padding: '10px 15px',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Guardar
            </button>
            <button 
              onClick={() => setMostrandoForm(false)}
              style={{
                backgroundColor: '#f5f5f5',
                color: '#333',
                border: '1px solid #ddd',
                padding: '10px 15px',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Cancelar
            </button>
          </div>
        </div>
      )}

      {/* Estado de carga */}
      {loading && (
        <div style={{ 
          padding: '30px', 
          textAlign: 'center', 
          backgroundColor: 'white',
          borderRadius: '10px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
          <p>Cargando plantillas...</p>
        </div>
      )}
      
      {/* Mensaje de error */}
      {error && (
        <div style={{ 
          padding: '30px', 
          textAlign: 'center', 
          backgroundColor: 'white',
          borderRadius: '10px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          color: '#f44336'
        }}>
          <p>{error}</p>
        </div>
      )}

      {/* Lista de plantillas */}
      {!loading && !error && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '20px' }}>
          {plantillas.map(plantilla => (
          <div key={plantilla.id} style={{ 
            backgroundColor: 'white', 
            borderRadius: '8px', 
            overflow: 'hidden',
            boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
          }}>
            {editandoId === plantilla.id ? (
              <div style={{ padding: '20px' }}>
                <div style={{ marginBottom: '15px' }}>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Nombre:</label>
                  <input 
                    type="text" 
                    value={plantillaEditada.nombre} 
                    onChange={(e) => setPlantillaEditada({...plantillaEditada, nombre: e.target.value})}
                    style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }}
                  />
                </div>
                <div style={{ marginBottom: '15px' }}>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Descripción:</label>
                  <textarea 
                    value={plantillaEditada.descripcion || ''} 
                    onChange={(e) => setPlantillaEditada({...plantillaEditada, descripcion: e.target.value})}
                    rows="5"
                    style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }}
                  ></textarea>
                </div>
                <div style={{ marginBottom: '15px' }}>
                  <label style={{ display: 'flex', alignItems: 'center' }}>
                    <input 
                      type="checkbox" 
                      checked={plantillaEditada.esPredeterminada} 
                      onChange={(e) => setPlantillaEditada({...plantillaEditada, esPredeterminada: e.target.checked})}
                      style={{ marginRight: '8px' }}
                    />
                    Establecer como plantilla predeterminada
                  </label>
                </div>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <button 
                    onClick={guardarEdicion}
                    style={{
                      backgroundColor: '#4caf50',
                      color: 'white',
                      border: 'none',
                      padding: '8px 12px',
                      borderRadius: '4px',
                      fontSize: '13px',
                      cursor: 'pointer'
                    }}
                  >
                    Guardar
                  </button>
                  <button 
                    onClick={() => setEditandoId(null)}
                    style={{
                      backgroundColor: '#f5f5f5',
                      color: '#333',
                      border: '1px solid #ddd',
                      padding: '8px 12px',
                      borderRadius: '4px',
                      fontSize: '13px',
                      cursor: 'pointer'
                    }}
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            ) : (
              <>
                <div style={{ padding: '15px', borderBottom: '1px solid #eee' }}>
                  <h3 style={{ margin: '0', fontSize: '18px' }}>{plantilla.nombre}</h3>
                  {plantilla.esPredeterminada && (
                    <span style={{
                      display: 'inline-block',
                      padding: '3px 8px',
                      backgroundColor: '#e8f5e9',
                      color: '#4caf50',
                      borderRadius: '12px',
                      fontSize: '12px',
                      marginTop: '5px'
                    }}>
                      Predeterminada
                    </span>
                  )}
                </div>
                <div style={{ padding: '15px' }}>
                  <p style={{ margin: '0', color: '#666' }}>
                    {plantilla.descripcion || 'Sin descripción'}
                  </p>
                  <div style={{ marginTop: '10px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                    <div style={{
                      padding: '8px',
                      backgroundColor: '#f1f8e9',
                      borderRadius: '4px',
                      fontSize: '13px'
                    }}>
                      <strong>{plantilla._count?.secciones || 0}</strong> secciones
                    </div>
                    <div style={{
                      padding: '8px',
                      backgroundColor: '#e8f5e9',
                      borderRadius: '4px',
                      fontSize: '13px'
                    }}>
                      <strong>{plantilla._count?.historiasClinicas || 0}</strong> historias
                    </div>
                  </div>
                </div>
                <div style={{ padding: '15px', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                  <button 
                    onClick={() => iniciarEdicion(plantilla)}
                    style={{
                      backgroundColor: '#3498db',
                      color: 'white',
                      border: 'none',
                      padding: '8px 12px',
                      borderRadius: '4px',
                      fontSize: '13px',
                      cursor: 'pointer'
                    }}
                  >
                    <i className="fas fa-edit" style={{ marginRight: '5px' }}></i>
                    Editar
                  </button>
                  <button 
                    onClick={() => eliminarPlantilla(plantilla.id)}
                    style={{
                      backgroundColor: '#e74c3c',
                      color: 'white',
                      border: 'none',
                      padding: '8px 12px',
                      borderRadius: '4px',
                      fontSize: '13px',
                      cursor: 'pointer'
                    }}
                  >
                    <i className="fas fa-trash" style={{ marginRight: '5px' }}></i>
                    Eliminar
                  </button>
                </div>
              </>
            )}
          </div>
        ))}
      </div>

      )}

      {!loading && !error && plantillas.length === 0 && !mostrandoForm && (
        <div style={{ 
          padding: '30px', 
          textAlign: 'center', 
          backgroundColor: 'white', 
          borderRadius: '8px', 
          marginTop: '20px',
          color: '#666'
        }}>
          No hay plantillas disponibles. Haga clic en "Nueva Plantilla" para crear una.
        </div>
      )}
    </div>
  );
};

export default Plantillas;